function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "9584DB69-9748-4C4F-855E-53C38A67D318");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "02_Wallet_L_1440_Full",
  transform: "translate(-792.000000, -512.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Voter-Registration",
  transform: "translate(736.000000, 456.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Voter-Registration-Card",
  transform: "translate(56.000000, 56.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Card-BG",
  fill: "#304FFE",
  x: 0,
  y: 0,
  width: 214,
  height: 134,
  rx: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M115,42 L179,42 C180.656854,42 182,43.3431458 182,45 C182,46.6568542 180.656854,48 179,48 L115,48 C113.343146,48 112,46.6568542 112,45 C112,43.3431458 113.343146,42 115,42 Z M115,64 L179,64 C180.656854,64 182,65.3431458 182,67 C182,68.6568542 180.656854,70 179,70 L115,70 C113.343146,70 112,68.6568542 112,67 C112,65.3431458 113.343146,64 115,64 Z M115,86 L179,86 C180.656854,86 182,87.3431458 182,89 C182,90.6568542 180.656854,92 179,92 L115,92 C113.343146,92 112,90.6568542 112,89 C112,87.3431458 113.343146,86 115,86 Z",
  id: "Lines",
  fill: "#243ACB",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Voter-Registration-Icon",
  transform: "translate(37.000000, 41.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#243ACB",
  x: 0,
  y: 5.52083333,
  width: 45,
  height: 45,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.0463298,6.92843966 C44.6410549,7.62662465 45,8.53181093 45,9.52083333 L45,19.6769022 L22.954262,43.382866 C21.089928,45.416638 17.9489885,45.3741851 16.1445803,43.2955005 L7.04402117,32.811624 C5.35940905,30.8709448 5.49680715,27.8943417 7.35249714,26.1275967 C9.24837301,24.322592 12.2103761,24.4680173 13.9313922,26.450634 L19.6946034,33.0898738 L43.9724381,7.00679634 C43.9968485,6.98032511 44.021481,6.95420619 44.0463298,6.92843966 Z",
  id: "Combined-Shape",
  fill: "#1C2CA2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.5525774,1.35288456 C48.7083779,-0.501245751 45.7508677,-0.44260784 43.9724381,1.485963 L19.6946034,27.5690405 L13.9313922,20.9298007 C12.2103761,18.947184 9.24837301,18.8017587 7.35249714,20.6067634 C5.49680715,22.3735084 5.35940905,25.3501115 7.04402117,27.2907907 L16.1445803,37.7746671 C17.9489885,39.8533517 21.089928,39.8958047 22.954262,37.8620327 L50.6655879,8.06381559 C52.4164679,6.15387412 52.3644501,3.17451407 50.5525774,1.35288456 Z",
  id: "Path-Copy",
  fill: "#FFFFFF"
}))))));

var SvgVoterRegistration = function SvgVoterRegistration(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "214px",
    height: "134px",
    viewBox: "0 0 214 134",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVoterRegistration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/voter-registration.38bce591.svg";
export { ForwardRef as ReactComponent };